(ns app.front.view.permit.list
  (:require [app.domain.verdict.model :as verdict-model]
            [app.domain.workspace.model :as workspace-model]
            [app.front.ui.table :as ui-table]
            [app.front.view.application.permissions :as permissions]
            [app.front.view.permit.download :as permit-download]
            [app.front.view.sign-off :as sign-off]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [core.util.util :as util]))


(defn permit-list [application workspace tr verdicts]
  (let [can-open-permit? (permissions/ws-child-has-permission? :permission.application/issue-permit application)
        sign-offs?       (some :verdict/sign-off-by verdicts)
        format-date      (<sub [::date-util/date-fn])]
    [ui-table/modern-responsive-table
     {:tr    tr
      :items verdicts
      :cols  (concat
               [[:verdict/municipal-permit-number
                 (fn [{:db/keys [id] :as verdict}]
                   (let [permit-number (or (verdict-model/verdict-or-licence-number verdict)
                                           (workspace-model/case-id workspace))]
                     (if (or can-open-permit?
                             (<sub [:app.front.process/app-signal-permitted?
                                    [:process.signal/permit-sign-off {:id id}]]))
                       (cc/link {:href       (href/href (if can-open-permit?
                                                          :view/permits
                                                          :view/sign-permits)
                                                        {:workspace-id (:workspace/id workspace)})
                                 :aria-label (tr [:verdict/view-permit])}
                                permit-number)
                       permit-number)))]
                [:verdict/issued-on
                 #(or (some-> % :verdict/issue-date format-date) "-")]
                [:verdict/issuer
                 #(or (:verdict/issuer %) "-")]
                [:verdict/status
                 #(tr [(:domain/state %)])]
                [:verdict/permit-document
                 (fn [{:domain/keys [state] :as verdict}]
                   (if (= state :verdict.state/permit-generating)
                     (cc/inline-loading {:description (tr [:verdict.state/permit-generating])})
                     [permit-download/download-button (util/mmap tr verdict)]))]]
               (when sign-offs?
                 [[""
                   (fn [verdict]
                     (when (and sign-offs?
                                (:verdict/sign-off-date verdict)
                                (:verdict/sign-off-by verdict))
                       [sign-off/signature (util/mmap {:created (:verdict/sign-off-date verdict)
                                                       :signer  (:verdict/sign-off-by verdict)} tr)]))]]))}]))
